import { Avatar, Stack, Typography } from "@mui/material";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import { Cross } from "akar-icons";
import { rgba } from "polished";
import React from "react";

import { useSmartrrTheme } from "@customer-app/account/views/OperationAquarius/hooks/useSmartrrTheme";

import { BundleBuilderItem } from "./BundleBuilderItem";
import { OverflowGrid, VerticalProductWrapper } from "../../../../../constants";
import { ProgressBar } from "../../../Bundles/ProgressBar";
import { ISelectedBundleItemsRow } from "../types";

export const SelectedBundleItemsRow = ({
  cartQuantityRef,
  cartRef,
  maxProductQuantity,
  updateCart,
  isLoading,
  remainingQuantity,
  clearCart,
}: ISelectedBundleItemsRow) => {
  const theme = useSmartrrTheme();
  return (
    <Stack
      direction="column"
      spacing="30px"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: rgba(theme?.modernPageBackground!, 0.5),
        borderRadius: theme.modernCardRadius,
        padding: "20px",
        overflowX: "hidden",
      }}
    >
      <ProgressBar
        steps={maxProductQuantity}
        progress={cartQuantityRef.current}
        config={{
          mainColor: "#f6c978",
          completionColor: "#7673D2",
          completionText: typedLocalize("editBundle.boxFull"),
        }}
      />
      <OverflowGrid
        container
        direction="row"
        width="100%"
        sx={{
          gap: "20px",
          flexWrap: "nowrap",
          overflowX: "scroll",
          width: "100% !important",
          marginRight: "-20px !important",
          transition: "0.3s ease-in-out",
          paddingBottom: "20px",
        }}
      >
        {cartRef.current?.length && !isLoading
          ? cartRef.current?.map(item => (
              <VerticalProductWrapper item key={item.id}>
                <BundleBuilderItem
                  key={item.id}
                  item={item}
                  updateCart={updateCart}
                  cartRef={cartRef}
                  maxProductQuantity={maxProductQuantity}
                  cartQuantityRef={cartQuantityRef}
                />
              </VerticalProductWrapper>
            ))
          : null}
        {/* Error Prevention */}
        {remainingQuantity > -1
          ? [...new Array(remainingQuantity)].map(i => (
              <VerticalProductWrapper key={i}>
                <Avatar> </Avatar>
              </VerticalProductWrapper>
            ))
          : null}
      </OverflowGrid>
      {cartRef.current?.length ? (
        <Stack
          direction="row"
          spacing="5px"
          onClick={clearCart}
          sx={{ cursor: "pointer", alignItems: "center", marginTop: "10px !important" }}
        >
          <Cross size={7} color={theme.modernIconsColor} />
          <Typography variant="caption1" sx={{ marginLeft: "5px", textDecoration: "underline" }}>
            {typedLocalize("editBundle.clear")}
          </Typography>
        </Stack>
      ) : null}
    </Stack>
  );
};
